import rest from "../script/rest";

class WattwaechterRest {

    async getFieldInterpolatedInSlice(calculationId, u, v, slice, fieldMax) {
        const url = "/rest/wattwaechter/getFieldInterpolatedInSlice"
            + "?calculationId=" + calculationId
            + "&slice=" + slice
            + "&fieldMax=" + fieldMax
            + "&u=" + u
            + "&v=" + v;
        const response = await rest.get(url);
        const json = await response.json();
        return json.value;
    }

    async getSlice(calculationId, imageSetting, viewType, fieldType) {
        const url = "/rest/wattwaechter/getSlice"
            + "?calculationId=" + calculationId
            + "&viewType=" + viewType
            + (fieldType ? "&fieldType=" + fieldType : "");
        const response = await rest.post(url, imageSetting);
        const result = await response.json();
        return result;
    }

    async getColorBar(calculationId, imageSetting, fieldType) {
        const url = "/rest/wattwaechter/getColorBar"
            + "?calculationId=" + calculationId
            + (fieldType ? "&fieldType=" + fieldType : "");
        const response = await rest.post(url, imageSetting);
        const json = await response.json();
        return json;
    }
}
const wattwaechterRest = new WattwaechterRest();
window.wattwaechterRest = wattwaechterRest;
export default wattwaechterRest;